import { InviteCodeContext } from '@rhg/providers/invite-code';
import { useContext } from 'react';

export function useInviteCode() {
    return useContext(InviteCodeContext);
}
